module.exports = __webpack_public_path__ + "static/media/park.ab6ceace.svg";